/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import UsePermission from 'src/hoc/UsePermission';
import PermissionHOC from 'src/hoc/PermissionHOC';
import SearchContainer from './SearchContainer';

const SearchContainerWithPermission = ({
    scope,
    editScope,
    fallback,
    where,
    show,
    ...rest
}) => {
    const hasRight = UsePermission({ scope: editScope });

    return (
        <PermissionHOC
            scope={scope}
            fallback={fallback}
        >
            <SearchContainer
                {...rest}
                hasEdit={hasRight}
                show={show}
                where={where}
            />
        </PermissionHOC>
    );
};

SearchContainerWithPermission.propTypes = {
    editScope: PropTypes.string.isRequired,
    fallback: PropTypes.object,
    scope: PropTypes.string.isRequired,
};

SearchContainerWithPermission.defaultProps = {
    fallback: null,
};

export default SearchContainerWithPermission;
